module.exports = __webpack_public_path__ + "img/puptitle6.acc0c8da.png";